import React, { useState } from "react";
import {
  Button,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Box,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { ClipboardList } from "lucide-react";
import { useDispatch } from "react-redux";
import { createNewAssessmentRequestStart } from "store/slices/assessmentSlice";
import { enqueueSnackbar } from "notistack";
import theme from "theme";

export default function Reassessment({ open, handleClose }) {
  const [formData, setFormData] = useState({
    reason: "",
  });

  const isMobile = useMediaQuery(() => theme.breakpoints.down("sm"));
  const dispatch = useDispatch();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const resetForm = () => {
    handleClose();
    setFormData({ reason: "" })
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(
      createNewAssessmentRequestStart({
        params: { reason: formData.reason },
        callback: (error, response) => {
          if (error) {
            const message = typeof error === "string" ? error : "Failed to create reassessment request.";
            enqueueSnackbar(message, {
              variant: "error",
              anchorOrigin: {
                vertical: isMobile ? "bottom" : "top",
                horizontal: isMobile ? "center" : "right",
              },
            });
          } else {
            enqueueSnackbar("Reassessment request submitted successfully.", {
              variant: "success",
              anchorOrigin: {
                vertical: isMobile ? "bottom" : "top",
                horizontal: isMobile ? "center" : "right",
              },
            });
            resetForm();
          }
        },
      })
    );
  };

  return (
    <Dialog
      open={open}
      onClose={resetForm}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          p: 1,
        },
      }}
    >
      <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <ClipboardList size={28} color="#8B5CF6" />
        <Typography variant="h6" fontWeight="bold">
          Request for Reassessment
        </Typography>
      </DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <Box>
            <TextField
              required
              id="reason"
              name="reason"
              label="Why do you need a reassessment?"
              fullWidth
              multiline
              minRows={3}
              variant="outlined"
              size="small"
              value={formData.reason}
              onChange={handleChange}
            />
            <Box
            sx={{
            mt: 2,
            p: 1.2,
            borderRadius: 2,
            backgroundColor: "#FFF7ED",
            display: "flex",
            alignItems: "flex-start",
            gap: 1,
            }}
          >

          <Box sx={{ fontSize: 18, lineHeight: 1 }}>⚠️</Box>
        <Typography
        sx={{
        fontSize: isMobile ? 12 : 13,
        color: "#D97706",
        lineHeight: 1.4,
        }}
        >
        Reassessment requests have a{" "}
        <Box component="span" fontWeight="bold">
          limited quota
        </Box>
          . Please submit carefully.
        </Typography>
        </Box>
          </Box>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            onClick={resetForm}
            variant="text"
            sx={{ textTransform: "none", color: "text.secondary" }}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            variant="contained"
            disabled={!formData.reason.trim()}
            sx={{
              textTransform: "none",
              borderRadius: 2,
              px: 4,
              background: "linear-gradient(to right, #3B82F6, #8B5CF6)",
              "&:hover": {
                background: "linear-gradient(to right, #3B82F6, #8B5CF6)",
              },
              "&:disabled": {
                background: "#e0e0e0",
              },
            }}
          >
            Submit Request
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
